import { SET_STATE, RESET, SET_CLASSROOM_TEAMS_ENABLED, SET_TEAMS, SET_TEAM_NAME, ADD_TEAM, ADD_TEAM_MEMBER, REMOVE_TEAM_MEMBER, SET_SELECTABLE_MEMBERS, DELETE_TEAM, MAKE_TEAM_CAPTAIN, REVOKE_TEAM_CAPTAIN } from './actionTypes'


import { SET_LICENSE } from '../licenses/actionTypes'

export function setState ( newState ) {
  return { type : SET_STATE, newState }
}

export function reset () {
  return { type : RESET }
}


export function showClassroomChooseChallenge( options = {} ){

  return (dispatch, getState) => {
    const url="index.php?component=com_otu_op&task=classroomTeams.showChooseChallenge";
    otuApp.triggerAjaxGet(url,{"attr":{"data-hide-template-position":"columns-all"}});	    
  }

}


export function showClassroomChooseChallengeLegacy() {
  // This is not the preferred way to open the choose challenge page

  return (dispatch, getState) => {

    dispatch( getTeamVersionState() )
    dispatch( getSelectableMembers() )
    dispatch( getMyClassroomTeams() )

    dispatch( { 
      type : SET_STATE, 
      newState : { 
        classroomChooseChallengeVisible : true,
        classroomTeamsPortalVisible : false,
        classroomTeamCreateVisible : false,
        classroomTeamManageVisible: false,
      } 
    }) 
  }
}

export function showClassroomTeamsPortal() {
  return (dispatch, getState) => {

    dispatch( getTeamVersionState() )
    dispatch( getSelectableMembers() )
    dispatch( getMyClassroomTeams() )

    dispatch( { 
      type : SET_STATE, 
      newState : { 
        classroomChooseChallengeVisible : false,
        classroomTeamsPortalVisible : true,
        classroomTeamCreateVisible : false,
        classroomTeamManageVisible: false,
      } 
    }) 
  }
}

export function saveTeam ( team ) {

  return ( dispatch, getState ) => {

    const data = {
      name : team.name,
      teamId : team.teamId
    }

    if (team.classroomTeam) {
      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classroomTeams.saveTeam',data,{
        responseType : 'json',
        noSysInteraction : true, 
        callback : function ( team ) {
  
        }
        } )
    } else {
      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=team.saveTeam',data,{
        responseType : 'json',
        noSysInteraction : true, 
        callback : function ( team ) {
  
        }
        } )
    }


    }

}

export function setTeamName ( options ) {
  
  return ( dispatch, getState ) => {

    const state = getState()

    dispatch( { 
        type : SET_TEAM_NAME, 
        team : options.team,
        name : options.name

      } 
    )

    const license = state.licenses.license;
    if (license.teamId==options.team.teamId){
      license.name=options.name
      dispatch({
        type : SET_LICENSE,
        license
      })
    }    



    dispatch( saveTeam( state.team.teams[ options.team.teamId ] ) )
  
  }

}

export function addMember ( options = {} ) {

  return ( dispatch, getState ) => {

    const team = options.team
    const member = options.member
    
    const data = {
      teamId : team.teamId,
      memberId : member.id,
      memberMissionId : member.missionId
    }

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classroomTeams.addMember',data,{
      responseType : 'json',
      noSysInteraction :false, 
      callback : function ( newMember ) {

        dispatch( { 
          type : ADD_TEAM_MEMBER, 
          member,
          team

        } )
      }
    } )

  }

}

export function removeMember ( options = {} ) {

  return ( dispatch, getState ) => {

    const team = options.team
    const member = options.member

    const data = {
      teamId : team.teamId,
      memberId : member.id
    }

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classroomTeams.removeMember',data,{
      responseType : 'json',
      noSysInteraction : false, 
      callback : function ( deletedMember ) {
        dispatch( { 
          type : REMOVE_TEAM_MEMBER, 
          team,
          member
        } )
      }
    } )

  }

}

export function makeTeamCaptain ( options = {} ) {

  return ( dispatch, getState ) => {

    const team = options.team
    const member = options.member

    const data = {
      teamId : team.teamId,
      memberId : member.id
    }

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classroomTeams.makeTeamCaptain',data,{
      responseType : 'json',
      callback : function (confirmation ) {
        dispatch( { 
          type : MAKE_TEAM_CAPTAIN, 
          team,
          member
        } )
      }
    } )

  }

}

export function revokeTeamCaptain ( options = {} ) {

  return ( dispatch, getState ) => {

    const team = options.team
    const member = options.member

    const data = {
      teamId : team.teamId,
      memberId : member.id
    }

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classroomTeams.revokeTeamCaptain',data,{
      responseType : 'json',
      callback : function ( confirmation ) {
        dispatch( { 
          type : REVOKE_TEAM_CAPTAIN, 
          team,
          member
        } )
      }
    } )

  }

}

export function deleteTeam( options = {} ) {
  
  return (dispatch, getState) => {
  
    const team = options.team
    const teamId = team.teamId 

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classroomTeams.deleteTeam', {
      teamId
    },
    { responseType : 'json',
      callback : ( confirmation ) => {
        dispatch( showClassroomTeamsPortal() )
        dispatch( { 
          type : DELETE_TEAM,
          team
        } )
      }
    } )
  
  }

}



export function getSelectableMembers ( options = {} ) {

  return (dispatch, getState) => {

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classroomTeams.getSelectableMembers', {},{
      responseType : 'json',
      callback : function ( selectableMembers ) {
        dispatch( { 
          type : SET_SELECTABLE_MEMBERS, 
          selectableMembers
        } )
      }
    } )
    
  }

}

export function getTeamVersionState() {
  return (dispatch, getState) => {

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classroomTeams.getTeamVersionState',{}, {
      responseType : 'json',
      callback : function ( classroomTeamState ) {
          dispatch ( {
            type : SET_CLASSROOM_TEAMS_ENABLED,
            enabled : classroomTeamState.enabled
          })
        }
      } 
    )
  }
}

export function getMyClassroomTeams() {

  return (dispatch, getState) => {

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classroomTeams.getMyTeams',{}, {
      responseType : 'json',
      callback : function ( teams ) {
          dispatch ( {
            type : SET_TEAMS,
            teams
          })

        }
      } 
    )
  }

}

export function getMyTeams() {

  return (dispatch, getState) => {

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=team.getMyTeams',{}, {
      responseType : 'json',
      callback : function ( teams ) {
          dispatch ( {
            type : SET_TEAMS,
            teams
          })

        }
      } 
    )
  }

}

export function enableTeamVersion( options = {}) {
  return (dispatch, getState) => {


    dispatch ( {
      type : SET_CLASSROOM_TEAMS_ENABLED,
      enabled : null
    })

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classroomTeams.enableTeamVersion',options, {
      responseType : 'json',
      callback : function ( classroomTeamState ) {

          dispatch ( {
            type : RESET,
            enabled : null
          })
          dispatch ( {
            type : SET_CLASSROOM_TEAMS_ENABLED,
          })
          if ( options.keepPortalOpen ) {
            dispatch ( showClassroomTeamsPortal() )
          } else {
            dispatch ( close() )
          }
        }
      } 
    )
  }

}

export function enableClassroomVersion( options = {}) {
  return (dispatch, getState) => {
    
    dispatch ( {
      type : SET_CLASSROOM_TEAMS_ENABLED,
      enabled : null
    })

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classroomTeams.enableClassroomVersion',options, {
      responseType : 'json',
      callback : function ( classroomTeamState ) {
          dispatch ( {
            type : RESET,
            enabled : null
          })
          dispatch ( {
            type : SET_CLASSROOM_TEAMS_ENABLED,
            enabled : classroomTeamState.enabled
          })
          dispatch ( close() )
        }
      } 
    )
  }

}

export function createClassroomTeam( team ) {
  return (dispatch, getState) => {

    const data = {
      name : team.name
    }

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classroomTeams.createTeam',data, {
      responseType : 'json',
      callback : function ( team ) {
          dispatch ( {
            type : ADD_TEAM,
            team
          })
          dispatch( showClassroomTeamsPortal() )
        }
      } 
    )
  }

}

export function showCreateTeam() {
  
  return (dispatch, getState) => {
    dispatch( { 
      type : SET_STATE, 
      newState : { 
        classroomChooseChallengeVisible : false,
        classroomTeamsPortalVisible : false,
        classroomTeamCreateVisible : true,
        classroomTeamManageVisible: false,
      } 
    } 
  )
  }

}

export function showManageTeam( options = {} ) {
  
  return (dispatch, getState) => {

        dispatch( { 
            type : SET_STATE, 
            newState : { 
              classroomChooseChallengeVisible : false,
              classroomTeamsPortalVisible : false,
              classroomTeamCreateVisible : false,
              classroomTeamManageVisible: true,
            } 
          } 
        )
  }

}

export function showTeam( options = {} ) {
  
  return (dispatch, getState) => {

    const team = options.team;

    var url="index.php?component=com_otu_op&task=classroomTeams.showTeam&teamId=" + team.teamId ;
    otuApp.triggerAjaxGet(url,{"attr":{"data-hide-template-position":"columns-all"}});
    
  }

}


export function closeManageTeam( options = {} ) {
  
  return (dispatch, getState) => {

        dispatch( { 
            type : SET_STATE, 
            newState : { 
              classroomChooseChallengeVisible : false,
              classroomTeamsPortalVisible : true,
              classroomTeamCreateVisible : false,
              classroomTeamManageVisible: false,
            } 
          } 
        )
  }

}

export function closeClassroomTeamCreate() {
  
  return (dispatch, getState) => {
  
    dispatch( { 
        type : SET_STATE, 
        newState : { 
          classroomChooseChallengeVisible : false,
          classroomTeamsPortalVisible : true,
          classroomTeamCreateVisible : false,
          classroomTeamManageVisible: false,
        } 
      } 
    )
  
  }
  
}

export function close() {
  
  return (dispatch, getState) => {
  
    dispatch( { 
        type : SET_STATE, 
        newState : { 
          classroomChooseChallengeVisible : false,
          classroomTeamsPortalVisible : false,
          classroomTeamCreateVisible : false,
          classroomTeamManageVisible: false,
        } 
      } 
    )

    // Always go to command center 

    //otuApp.triggerAjaxGet(otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=goToProfile');

    otuApp.pageNavigation.restoreTask();
  
  }
  
}


